// import store from "../store";

// const subscriptionFeatures = store.getters.subscriptionData.subscriptionFeatures;

// console.log(subscriptionFeatures)

export default {
  getVariableIndex(dataset,nidle) {
   return dataset.findIndex(
      (x) => x.question_variable === nidle
    );
  },
  onclickCopyQuestions(event,questionData) {
    if (event) {
      event.forEach((element) => {
        // console.log(element);
        questionData.questions.push({
          question: element.question,
          question_variable: "",
          question_bangla: element.question_bangla,
          ui_category_id: element.ui_category_id,
          required_optional: element.required_optional,
          multiple_answer: element.multiple_answer,
          instruction: element.instruction
            ? element.instruction.instruction
            : null,
          instruction_bangla: element.instruction_bangla
            ? element.instruction_bangla.instruction
            : null,
          description: element.description
            ? element.description.description
            : null,
          description_bangla: element.description_bangla
            ? element.description_bangla.description
            : null,
          error_message: "",
          boolean1: false,
          boolean2: false,
          has_logic: false,
          date_time: "date & time",
          child_variables: [],
          logic_variables: [],
          logic_group: [
            {
              logic_set: [
                {
                  q_index: "",
                  logic_operator_id: "",
                  logic_input: "",
                  logic_condition: "",
                  logic_input_ui_type: "",
                  logic_operator: [],
                },
              ],
            },
          ],
          options:
            element.ui_category_id == 1 &&
            this.isLanguageEnglish(element.project_language) &&
            element.options.length > 0
              ? element.options
              : [
                  {
                    title: "option1",
                    value: 1,
                  },
                ],
          options_bangla:
            element.ui_category_id == 1 &&
            this.isLanguageBangla(element.project_language) &&
            element.bangla_options.length > 0
              ? element.bangla_options
              : [
                  {
                    title: "অপশন১",
                    value: 1,
                  },
                ],
          images: [
            {
              url: element.imageOptions.url || "",
              id: element.imageOptions.id || "",
              value: 1,
              name: element.imageOptions.name || "",
            },
          ],
          option_values: {
            min: element.option_val ? element.option_val.min_value || 1 : 1,
            max: element.option_val ? element.option_val.max_value || "" : "",
            interval: element.option_val
              ? element.option_val.interval || ""
              : "",
          },
          contactInfo: {
            first_name: true,
            middle_name: true,
            last_name: false,
            phone: true,
            email: true,
            address: false,
          },
          openEnded: {
            text_type: "",
            condition: "",
            conditional_number: "",
            conditional_text: "",
            custom_error: "",
          },
        });
        if (questionData.questions.length > 1) {
          questionData.current_question_id = parseInt(
            questionData.current_question_id + 1
          );
          questionData.ui_category_price[
            questionData.current_question_id
          ] = this.indexData.uiCategories[element.ui_category_id - 1].price;
        } else {
          questionData.current_question_id = 1;
          questionData.ui_category_price[
            questionData.current_question_id
          ] = this.indexData.uiCategories[element.ui_category_id - 1].price;
        }
        questionData.questions[
          questionData.questions.length - 1
        ].question_variable = "var" + questionData.current_question_id;
      });
      this.dialog2 = false;
    } else {
      this.dialog2 = false;
    }
  },
};
